<template>
    <b-modal ref="mdlRsaPazientePaiDomiciliareEditModal" id="mdlRsaPazientePaiDomiciliareEditModal" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" dialog-class="sa-modal-fill-height" :ok-disabled="!isOkDisable" @ok="onOkSalva" @hide="onHide">
        <div class="sa-pai-domiciliare-edit-wrapper">
            <div class="sa-pai-domiciliare-section">
                <div class="sa-pai-domiciliare-section-header">
                    <i class="fas fa-id-card mr-2"></i> Inquadramento e Diagnosi
                    <span :class="['ml-2 badge', isMasterValid ? 'badge-success' : 'badge-danger']">
                        {{ isMasterValid ? "OK" : "Incompleto" }}
                    </span>
                </div>
                <div class="sa-pai-domiciliare-section-body p-3">
                    <b-row>
                        <b-col md="6">
                            <label class="sa-pai-domiciliare-label">Data Prima Attivazione:</label>
                            <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataPrimaAttivazione" type="date"></date-picker>
                        </b-col>
                        <b-col md="6">
                            <label class="sa-pai-domiciliare-label">ID PAI:</label>
                            <b-form-input :value="jsonData.id || 'NUOVO'" readonly class="bg-light"></b-form-input>
                        </b-col>
                        <b-col md="12">
                            <label class="sa-pai-domiciliare-label">Diagnosi / Note Cliniche:</label>
                            <b-form-textarea v-model="jsonData.diagnosi" rows="6" no-resize placeholder="Inserire diagnosi clinica del paziente..."></b-form-textarea>
                        </b-col>
                        <b-col md="12">
                            <label class="sa-pai-domiciliare-label">Obiettivi e risultati attesi:</label>
                            <b-form-textarea v-model="jsonData.obiettiviRisultatiAttesi" rows="6" no-resize placeholder="Inserire obiettivi e risultati attesi clinica del paziente..."></b-form-textarea>
                        </b-col>
                        <b-col md="12">
                            <label class="sa-pai-domiciliare-label">Piano Teraupetico:</label>
                            <b-form-textarea v-model="jsonData.pianoTerapeutico" rows="6" no-resize placeholder="Inserire piano teraupetico clinica del paziente..."></b-form-textarea>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div></div>
            <!-- <hr class="my-4 border-light" /> -->

            <div class="sa-pai-domiciliare-section">
                <div class="sa-pai-domiciliare-section-header d-flex justify-content-between align-items-center">
                    <span>
                        <i class="fas fa-hand-holding-medical mr-2"></i> Pianificazione Accessi
                        <span :class="['ml-2 badge', isDetailValid ? 'badge-success' : 'badge-danger']">
                            {{ isDetailValid ? "OK" : "Min. 1 riga completa" }}
                        </span>
                    </span>
                    <b-button variant="success" size="sm" @click="aggiungiAccesso" pill class="shadow-sm"> <i class="fas fa-plus mr-1"></i> Aggiungi Prestazione </b-button>
                </div>

                <div class="sa-pai-domiciliare-section-body">
                    <div v-if="jsonData.listaAccessi && jsonData.listaAccessi.length > 0">
                        <div v-for="(jsonData, index) in jsonData.listaAccessi" :key="index" :class="['sa-pai-domiciliare-detail-card', isCardValid(jsonData) ? 'sa-pai-domiciliare-card-valid' : '']">
                            <div class="sa-pai-domiciliare-card-header">
                                <span class="text-primary font-weight-bold"><i class="fas fa-notes-medical mr-2"></i>Prestazione #{{ index + 1 }}</span>
                                <b-button variant="outline-danger" @click="rimuoviAccesso(index)"> <i class="fas fa-trash-alt"></i> Rimuovi </b-button>
                            </div>

                            <div class="card-body p-3">
                                <b-row>
                                    <b-col md="4">
                                        <label class="sa-pai-domiciliare-label">Categoria Servizio:</label>
                                        <b-form-select v-model="jsonData.categoria" :options="opzioniCategorie"></b-form-select>
                                    </b-col>
                                    <b-col md="8">
                                        <label class="sa-pai-domiciliare-label">Tipo Intervento:</label>
                                        <b-form-input v-model="jsonData.tipoIntervento" placeholder="Es: Gestione stomia, Fisioterapia..."></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col md="3">
                                        <label class="sa-pai-domiciliare-label">Occasionali:</label>
                                        <b-form-input type="number" v-model.number="jsonData.numeroAccessiOccasionali"></b-form-input>
                                    </b-col>
                                    <b-col md="3">
                                        <label class="sa-pai-domiciliare-label">Giornalieri:</label>
                                        <b-form-input type="number" v-model.number="jsonData.numeroAccessiGiornalieri"></b-form-input>
                                    </b-col>
                                    <b-col md="3">
                                        <label class="sa-pai-domiciliare-label">Settimanali:</label>
                                        <b-form-input type="number" v-model.number="jsonData.numeroAccessiSettimanali" @input="onSettimanaliChange(jsonData)"></b-form-input>
                                    </b-col>
                                    <b-col md="3">
                                        <label class="sa-pai-domiciliare-label">Mensili:</label>
                                        <b-form-input type="number" v-model.number="jsonData.numeroAccessiMensili"></b-form-input>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                    <div v-else class="sa-pai-domiciliare-empty-placeholder text-center">
                        <i class="fas fa-clipboard-list fa-2x mb-2 text-muted"></i>
                        <p class="mb-0">Nessuna prestazione pianificata. Clicca su "Aggiungi Prestazione" per iniziare.</p>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPaiDomiciliareMixin from "../mixins/RsaPaiDomiciliareMixin";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin, RsaPaiDomiciliareMixin],
    data() {
        return {
            pathresource: "/rsapaidomiciliare",
            jsonData: { dataPrimaAttivazione: null, id: null, listaAccessi: [] },
            opzioniCategorie: [
                { value: null, text: "Scegli Categoria..." },
                { value: "Infermieristica", text: "Infermieristica" },
                { value: "Riabilitativa", text: "Riabilitativa" },
                { value: "Sociale", text: "Sociale" },
                { value: "Assistenziale", text: "Assistenziale" },
            ],
        };
    },
    computed: {
        title() {
            return this.jsonData.id ? "Modifica P.A.I." : "Nuovo P.A.I.";
        },
        isMasterValid() {
            return !!(this.jsonData.dataPrimaAttivazione && this.jsonData.diagnosi && this.jsonData.diagnosi.trim().length > 3);
        },
        isDetailValid() {
            const hasItems = this.jsonData.listaAccessi && this.jsonData.listaAccessi.length > 0;
            return hasItems && this.jsonData.listaAccessi.every((jsonData) => this.isCardValid(jsonData));
        },
        isOkDisable() {
            return this.isMasterValid && this.isDetailValid;
        },
    },
    methods: {
        init() {},
        show(idAccettazione) {
            let me = this;
            me.jsonData = { idAccettazione: idAccettazione, dataPrimaAttivazione: null, id: null, listaAccessi: [] };
            this.$refs.mdlRsaPazientePaiDomiciliareEditModal.show();
        },
        showModificaPai(id) {
            let me = this;
            me.loadPaiDomiciliare(id, me.afterLoadPaiDomiciliare);
            this.$refs.mdlRsaPazientePaiDomiciliareEditModal.show();
        },
        afterLoadPaiDomiciliare() {
            let me = this;
            me.jsonData = me.paiDomiciliare;
            //me.jsonData.dataPrimaAttivazione = me.jsonData.dataPrimaAttivazione * 1;
            this.jsonData.dataPrimaAttivazione = Number(this.jsonData.dataPrimaAttivazione);
        },
        isCardValid(jsonData) {
            return !!(jsonData.categoria && jsonData.tipoIntervento && jsonData.tipoIntervento.trim().length > 2);
        },
        aggiungiAccesso() {
            if (!this.jsonData.listaAccessi) this.$set(this.jsonData, "listaAccessi", []);
            this.jsonData.listaAccessi.push({
                categoria: null,
                numeroAccessiSettimanali: 0,
                numeroAccessiMensili: 0,
                numeroAccessiOccasionali: 0,
                numeroAccessiGiornalieri: 0,
                tipoIntervento: "",
                createDate: Date.now(),
            });
        },
        rimuoviAccesso(index) {
            this.jsonData.listaAccessi.splice(index, 1);
        },
        onSettimanaliChange(jsonData) {
            jsonData.numeroAccessiMensili = (jsonData.numeroAccessiSettimanali || 0) * 4;
        },
        /*   () {
            this.$emit("input", this.jsonData);
            this.$emit("validation-change", this.isMasterValid && this.isDetailValid);
        }, */
        onOkSalva(bvModalEvent) {
            let me = this;
            bvModalEvent.preventDefault();
            me.saveResource(me.pathresource, me.jsonData, () => this.$bvModal.hide("mdlRsaPazientePaiDomiciliareEditModal"), null);
        },
        onHide() {
            let me = this;
            me.$emit("afterCloseModal");
        },
    },
};
</script>

<style scoped>
::v-deep .modal-body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
}

.sa-pai-domiciliare-edit-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    padding: 15px;
}
.sa-pai-domiciliare-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

.sa-pai-domiciliare-section:first-of-type {
    flex: 0 0 auto;
    max-height: 40%;
    overflow-y: auto;
}

.sa-pai-domiciliare-section:last-of-type {
    flex: 1 1 auto;
    min-height: 0;
    border-top: 1px solid #e3e6f0;
    padding-top: 10px;
}

.sa-pai-domiciliare-section-header {
    font-size: 1.1rem;
    font-weight: 700;
    color: #4e73df;
    padding-bottom: 8px;
    flex-shrink: 0;
}

.sa-pai-domiciliare-section-body {
    overflow-y: auto;
    padding: 5px;
}

.sa-pai-domiciliare-label {
    font-size: 0.95rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #999;
    margin-bottom: 4px;
    display: block;
}

.sa-pai-domiciliare-detail-card {
    border: 1px solid #e3e6f0;
    border-left: 5px solid #e74a3b;
    border-radius: 8px;
    margin-bottom: 15px;
    background: #fff;
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.05);
    transition: all 0.2s ease-in-out;
}

.sa-pai-domiciliare-card-valid {
    border-left-color: #1cc88a;
}

.sa-pai-domiciliare-card-header {
    background: #f8f9fc;
    padding: 10px 15px;
    border-bottom: 1px solid #e3e6f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
}

.sa-pai-domiciliare-empty-placeholder {
    padding: 40px;
    text-align: center;
    border: 2px dashed #b3b3b3;
    border-radius: 12px;
    color: #8a8a8a;
    background-color: #f0f0f0;
    margin-top: 10px;
}
</style>
